import {AppBar, Button, ButtonGroup, IconButton, Toolbar, useTheme} from "@mui/material";
import SvgIconTelegram from "../util/SvgIconTelegram";
import SvgIconVK from "../util/SvgIconVK";
import SvgIconYouTube from "../util/SvgIconYouTube";
import SvgIconTikTok from "../util/SvgIconTikTok";
import React from "react";
import SvgIconX from "../util/SvgIconX";
import SvgIconBluesky from "../util/SvgIconBluesky";
import {useLocale} from "../locale/Locale";

function AppBarBottom() {

    const {setLocale} = useLocale()

    return (
        <>
            <AppBar position="static">
                <Toolbar>
                    <ButtonGroup color={"secondary"} size={"small"} sx={{flexGrow: 1}}>
                        <Button onClick={() => setLocale('ru')}>RU</Button>
                        <Button onClick={() => setLocale('en')}>EN</Button>
                    </ButtonGroup>
                    <IconButton
                        href="https://t.me/isaev_inc"
                        target="_blank"
                        color="primary"
                    >
                        <SvgIconTelegram/>
                    </IconButton>
                    <IconButton
                        href="https://vk.com/isaev_inc"
                        target="_blank"
                        color="info"
                    >
                        <SvgIconVK/>
                    </IconButton>
                    <IconButton
                        href="https://tiktok.com/@isaev_inc"
                        target="_blank"
                    >
                        <SvgIconTikTok/>
                    </IconButton>
                    <IconButton
                        href="https://youtube.com/@isaev_inc"
                        target="_blank"
                        color="error"
                    >
                        <SvgIconYouTube/>
                    </IconButton>
                    <IconButton
                        href="https://x.com/ISAEV_SPACE"
                        target="_blank"
                    >
                        <SvgIconX sx={{color: useTheme().palette.text.primary}}/>
                    </IconButton>
                    <IconButton
                        href="https://bsky.app/profile/isaevspace.bsky.social"
                        target="_blank"
                        color="error"
                    >
                        <SvgIconBluesky sx={{color: useTheme().palette.text.primary}}/>
                    </IconButton>
                </Toolbar>
            </AppBar>
        </>
    )
}

export default AppBarBottom
